module.exports = __webpack_public_path__ + "static/media/spinner.5deea265.svg";